import { ReactNode, useContext, useState, createContext } from "react";

interface ILayoutContextData {
    loading: boolean;
    isMenuCollapsed: boolean;

    setLoading: (state: boolean) => void;
    toggleMenu: () => void;
}

export const LayoutContext = createContext({} as ILayoutContextData);

interface ILayoutContextProviderProps {
    children: ReactNode;
}

export function LayoutContextProvider({ children }: ILayoutContextProviderProps) {
    const [loading, setLoading] = useState(false);
    const keyStorage = "menuCollapsed";
    const [isMenuCollapsed, setIsMenuCollapsed] = useState(getIsMenuCollapsed());
    const handleChangeLoading = (state: boolean) => setLoading(loading);

    function toggleMenu() {
        const body = document.body;

        body.classList.toggle("vertical-collpsed");
        body.classList.toggle("sidebar-enable");
        setIsMenuCollapsed(getIsMenuCollapsed());
        const isCollapsed = body.classList.contains("vertical-collpsed");
        localStorage.setItem(keyStorage, JSON.stringify(!isCollapsed));
    }

    function getIsMenuCollapsed() {
        const value = localStorage.getItem(keyStorage);
        if (value) {
            return value === "true";
        }
        const body = document.body;
        return body.classList.contains("vertical-collpsed");
    }

    return (
        <LayoutContext.Provider
            value={{
                loading,
                isMenuCollapsed,

                setLoading: handleChangeLoading,
                toggleMenu
            }}>
            {children}
        </LayoutContext.Provider>
    )
}

export const useLayoutContext = () => {
    return useContext(LayoutContext);
}